<script>

import PersonNameConverter from "../Services/PersonNameConverter";
import scholarshipMeetingApi from "../Services/Api/MeetingApi/ScholarshipMeetingApi";
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: 'scholarship_meeting/getPayloadMeeting',
  mutationType: 'scholarship_meeting/updatePayloadMeeting',
});


import TheMeetingDatePicker from "./DatePicker/TheMeetingDatePicker.vue";
import _ from "lodash";
import {mapMutations, mapState} from "vuex";
export default {
  name: "TheMeetingScholarshipParameterForm",

  components: {
    TheMeetingDatePicker,
  },

  props: {
    dialog: {
      type: Boolean,
    }
  },

  data() {
    return {
      searchChairman: "",
      searchSecretary: "",
      searchListeners: "",
      searchChairmanStudent: "",
      people: [],
    };
  },

  watch: {
    searchSecretary: async function () {
      if (!this.dialog) return
      await this.setPeopleData(this.searchSecretary);
    },

    searchListeners: async function () {
      if (!this.dialog) return
      await this.setPeopleData(this.searchListeners);
    },

    searchChairman: async function () {
      if (!this.dialog) return
      await this.setPeopleData(this.searchChairman);
    },

    searchChairmanStudent: async function () {
      if (!this.dialog) return
      await this.setPeopleData(this.searchChairmanStudent);
    },
  },

  mounted() {
    this.people = [...this.people, ...this.memberCurrentMeeting]
  },

  computed: {
    PersonNameConverter() {
      return PersonNameConverter
    },

    ...mapState({
      meeting: state => state.scholarship_meeting.meeting,
      payload: state => state.scholarship_meeting.payload,
    }),

    ...mapFields([
      "listeners",
      "chairman",
      "secretary",
      "number_seats_available",
      "student_chairman_asset",
    ]),

    memberCurrentMeeting() {
      return _.compact([
        ...this.payload.listeners,
        this.payload.chairman,
        this.payload.secretary,
        this.payload.student_chairman_asset
      ])
    },

  },

  methods: {

    ...mapMutations({
      spliceListeners: "scholarship_meeting/spliceListeners",
    }),

    async personSearchFromServer(search) {
      const response = await scholarshipMeetingApi.searchPerson(search);

      if (_.isNil(response)) return [];
      return response.data
    },

    async setPeopleData(searchFieldForm) {
      const data = await this.personSearchFromServer(searchFieldForm);
      this.people = [...this.memberCurrentMeeting, ...data]
    },

  },
}
</script>

<template>
  <v-row>
    <v-col cols="12">
      <v-row class="py-0">
        <v-col cols="6">
          <the-meeting-date-picker/>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="number_seats_available"
            outlined
            color="teal darken-3"
            label="Количество мест"
            class="rounded-xl"
            dense
            type="number"
            min="0"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-autocomplete
        :items="people"
        :search-input.sync="searchChairman"
        v-model="chairman"
        color="teal darken-3"
        item-text="full_name"
        return-object
        label="Председатель"
        dense
        outlined
        class="rounded-xl"
      >
        <template #no-data>
          Список пуст
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12">
      <v-autocomplete
        :items="people"
        :search-input.sync="searchSecretary"
        v-model="secretary"
        color="teal darken-3"
        item-text="full_name"
        return-object
        label="Секретарь"
        dense
        outlined
        class="rounded-xl"
      >
        <template #no-data>
          Список пуст
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12">
      <v-autocomplete
        :items="people"
        :search-input.sync="searchChairmanStudent"
        v-model="student_chairman_asset"
        color="teal darken-3"
        item-text="full_name"
        return-object
        label="Председатель студ. актива"
        dense
        outlined
        class="rounded-xl"
      >
        <template #no-data>
          Список пуст
        </template>
      </v-autocomplete>
    </v-col>

    <v-col>
      <v-autocomplete
        :items="people"
        v-model="listeners"
        :search-input.sync="searchListeners"
        outlined
        chips
        color="teal darken-3"
        label="Присутствовали"
        item-text="full_name"
        return-object
        multiple
        class="rounded-xl"
        no-data-text="Отсутствуют слушатели для данного факультета"
      >
        <template #selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            small
            close
            @click="data.select"
            @click:close="spliceListeners(data.item)"
          >
            {{PersonNameConverter.shortName(data.item.full_name) }}
          </v-chip>
        </template>
        <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title v-html="data.item.full_name"></v-list-item-title>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-col>

  </v-row>
</template>

<style scoped>

</style>